import { combineReducers } from 'redux';
import shop from './ShopReducer';

const rootReducers = combineReducers({
  shop
});

export default rootReducers;